<template>
  <b-modal
    modal-class="mc-modal-dashboard"
    id="modalFleets"
    ref="modalFleets"
    :title="$t('global.object.fleetList')"
    header-close-variant="light"
    :ok-title="$t('global.action.close')"
    ok-variant="outline-primary"
    ok-only
    size="lg"
    centered
    scrollable
  >
    <b-row align-h="between">
      <b-col cols="4">
        <b-badge class="bg-success" v-if="vehicleStatusType === 'moving'">{{
          $t('global.filter.running')
        }}</b-badge>
        <b-badge class="bg-warning" v-else-if="vehicleStatusType === 'idle'">{{
          $t('global.filter.idle')
        }}</b-badge>
        <b-badge class="bg-secondary" v-else-if="vehicleStatusType === 'offline'">{{
          $t('global.filter.offline')
        }}</b-badge>
        <b-badge class="bg-danger" v-else-if="vehicleStatusType === 'parking'">{{
          $t('global.filter.parking')
        }}</b-badge>
        <b-badge class="bg-info" v-else-if="vehicleStatusType === 'assisted'">{{
          $t('global.filter.assisted')
        }}</b-badge>
      </b-col>
      <b-col cols="8" class="text-end">
        <label class="d-inline-flex align-items-center mc-table-view__search" @click="focusSearch">
          <i class="mc-fa fas fa-search"></i>
          <b-form-input
            type="search"
            :placeholder="$t('global.search') + '...'"
            class="form-control ms-2"
            v-model="filter"
            ref="searchInput"
          ></b-form-input>
        </label>
      </b-col>
    </b-row>

    <div class="table-responsive my-3 border border-1">
      <b-table
        small
        show-empty
        :items="items"
        :fields="fields"
        class="datatables"
        responsive="md"
        size="sm"
        sort-by="notifType"
        :empty-text="$t('global.emptyTable')"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        @filtered="onFiltered"
      >
      </b-table>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label>
            <p>
              {{ $t('global.text.displays') }}
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
              {{ $t('global.text.entries') }}.
            </p>
            <p>
              {{ $t('global.text.display') }}&nbsp;<strong>{{
                items.length > 0 ? (currentPage - 1) * perPage + 1 : 0
              }}</strong
              >&nbsp;{{ $t('global.object.to') }}&nbsp;<strong>{{
                Math.min(items.length, currentPage * perPage)
              }}</strong
              >&nbsp;{{ $t('global.object.of') }}&nbsp;<strong>{{ items.length }}</strong
              >&nbsp;{{ $t('global.entry') }}.
            </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              size="sm"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      reqired: true,
    },
    vehicleStatusType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filter: null,

      currentPage: 1,
      perPage: 10,
      rows: 0,
      pageOptions: [10, 25, 50, 100],
    }
  },
  mounted() {
    this.rows = this.items.length
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length
      this.currentPage = 1
    },
  },

  computed: {
    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          sortable: true,
        },
        {
          key: 'vehicle.vehicleType.category',
          label: this.$t('global.object.fleetCategory'),
          sortable: false,
        },
        {
          key: 'vehicle.driver1.fullname',
          label: this.$t('global.object.driverName'),
          sortable: false,
        },
      ]
    },
  },
}
</script>
